import { Navigate } from '@tanstack/react-router';

import { useDashboardsQuery } from './query';
import { PageSpinner } from '../../common/components/cookbook/PageSpinner';

export const RedirectToIndexDashboard = () => {
  const { data, isLoading } = useDashboardsQuery();

  if (isLoading || !data?.length) {
    return <PageSpinner />;
  }

  const indexDashboardId = data[0].id;
  return (
    <Navigate to="/analytics/$dashboardId" params={{ dashboardId: indexDashboardId }} replace />
  );
};
